import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userSlice from "./slice/userslice";
import userContentSlice from "./slice/userContentSlice";
import { encryptTransform } from "redux-persist-transform-encrypt";
// const encryptTransform =
//   require("redux-persist-transform-encrypt").encryptTransform;
const encryptor = encryptTransform({
  secretKey: `${process.env.SECURE_LOCAL_STORAGE_HASH_KEY}`,
  onError: (error: any) => {
    console.error("Encryption error:", error);
  },
});

const persistConfig = {
  key: "root",
  version: 0,
  storage,
  transforms: [encryptor],
};

const rootReducer = combineReducers({
  user: userSlice,
  userContent: userContentSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const saveToSessionStorage = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem("state", serializedState);
  } catch (e) {
    console.log(e);
  }
};
store.subscribe(() => saveToSessionStorage(store.getState()));

export default store;
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
